<script setup>
import { ref } from 'vue'
import { formatDateLocale } from '@/libs/utils/date.js'

import QuestionGroupComponent from '@/components/CMB/Components/QuestionGroupComponent.vue'

defineProps(['handleAnswer', 'compiledPoll', 'form'])
const confirmSend = ref(false)

</script>

<template>
  <div class="poll-component mx-2" v-if="compiledPoll['poll']">
    <h5 v-if="compiledPoll['state'] === 'filled'">
      Compilato il: {{ formatDateLocale(compiledPoll['filledDate']) }}
    </h5>
    <div class="alert alert-danger d-none form-errors">
      Errore nella compilazione del questionario, controlla i dati e riprova
    </div>
  </div>

  <div
    v-if="compiledPoll['poll']"
    :id="questionGroup.id"
    v-for="questionGroup in compiledPoll['poll']['questionGroups']"
    :key="questionGroup.id"
    class="px-0"
  >
    <question-group-component
      :compiled-poll="compiledPoll"
      :handle-answer="handleAnswer"
      :question-group="questionGroup"
    ></question-group-component>

    <div :class="'modal ' + (confirmSend ? 'd-block' : '')" tabindex="-1">
      <div class="backdrop">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Conferma invio</h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                @click="confirmSend = false"
              ></button>
            </div>
            <div class="modal-body">
              <p>
                Una volta inviato il questionario non potrà essere più
                modificato/rinviato.
              </p>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
                @click="confirmSend = false"
              >
                Annulla
              </button>
              <button type="button" class="btn btn-primary" @click="sendFilled">
                Invia
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
